class AmCatalog extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.grid = this.querySelector('.am-catalog-grid');
    this.cards = [...this.querySelectorAll('[data-am-card]')].map((el, index) => ({el, item: el.closest('li'), index, choices: JSON.parse(el.querySelector('[data-am-choices]').textContent)}));
    this.material = this.querySelector('[data-material]');
    this.kind = this.querySelector('select[data-kind]');
    this.sort = this.querySelector('[data-sort]');
    const url = new URL(location.href);
    const legacy = url.searchParams.get('filter.v.option.materiaal');
    // Migrate former native material filters, which exclude single-material products.
    if (legacy) {
      url.searchParams.delete('filter.v.option.materiaal');
      url.searchParams.delete('page');
      url.searchParams.set('am_material', /verguld/i.test(legacy) ? 'plated' : /14k/i.test(legacy) ? 'gold' : 'silver');
      location.replace(url.href); return;
    }
    const materials = new Set(this.cards.flatMap(c => c.choices.map(v => v.code)).filter(c => c && c !== 'all'));
    const kinds = new Set(this.cards.map(c => c.el.dataset.kind));
    if (this.material) {
      [...this.material.options].forEach(o => { if (o.value && !materials.has(o.value)) o.remove(); });
      this.querySelector('[data-material-field]').hidden = !!this.dataset.context || materials.size <= 1;
    }
    if (this.kind) {
      [...this.kind.options].forEach(o => { if (o.value && !kinds.has(o.value)) o.remove(); });
      this.querySelector('[data-type-field]').hidden = this.kind.options.length <= 2;
    }
    this.onChange = () => this.apply(true);
    this.onPop = () => { this.readURL(); this.apply(false); };
    this.addEventListener('change', this.onChange);
    this.resetButtons = [...this.querySelectorAll('[data-reset]')];
    this.onReset = () => {
      if (this.material) this.material.value = '';
      if (this.kind) this.kind.value = '';
      this.apply(true);
      const control = [this.material, this.kind, this.sort].find(field => field && !field.closest('[hidden]'));
      control?.focus();
    };
    this.resetButtons.forEach(button => button.addEventListener('click', this.onReset));
    window.addEventListener('popstate', this.onPop);
    this.readURL(); this.apply(false);
  }
  readURL() {
    const p = new URL(location.href).searchParams;
    if (this.material) this.material.value = p.get('am_material') || '';
    if (this.kind) this.kind.value = p.get('am_kind') || '';
    if (this.sort) this.sort.value = p.get('am_sort') || 'featured';
  }
  // Pagination links are rendered server-side before any client-side filtering,
  // so their hrefs must be rewritten or page 2 silently drops the active filters.
  syncPagination(params) {
    this.querySelectorAll('.pagination a[href], .pagination__list a[href]').forEach(a => {
      const href = a.getAttribute('href');
      if (!href || href.startsWith('#')) return;
      const link = new URL(href, location.origin);
      ['am_material', 'am_kind', 'am_sort'].forEach(k => {
        const v = params.get(k);
        if (v) { link.searchParams.set(k, v); } else { link.searchParams.delete(k); }
      });
      a.setAttribute('href', link.pathname + link.search);
    });
  }
  apply(updateURL) {
    const material = this.dataset.context || this.material?.value || '';
    const kind = this.kind?.value || '';
    const sort = this.sort?.value || 'featured';
    let count = 0;
    this.cards.forEach(c => {
      const choice = c.choices.find(v => v.code === (material || 'all'));
      c.item.hidden = !choice || (!!kind && c.el.dataset.kind !== kind);
      if (c.item.hidden) return;
      count++;
      c.price = choice.price;
      c.el.querySelectorAll('[data-am-link]').forEach(a => { a.href = choice.url; });
      c.el.querySelector('[data-am-amount]').textContent = choice.amount;
      const img = c.el.querySelector('img');
      if (img && choice.image) { img.srcset = choice.srcset; img.src = choice.image; }
    });
    const sorted = [...this.cards].sort((a,b) => sort === 'price_low' ? (a.price || 0)-(b.price || 0) : sort === 'price_high' ? (b.price || 0)-(a.price || 0) : sort === 'title' ? a.el.dataset.name.localeCompare(b.el.dataset.name,'nl') : a.index-b.index);
    sorted.forEach(c => this.grid.append(c.item));
    const output = this.querySelector('[data-count-output]');
    const countLabel = count === 1 && this.dataset.countOne ? this.dataset.countOne : this.dataset.count;
    if (output) output.textContent = countLabel.replace('[count]', count);
    const activeReset = this.querySelector('[data-active-reset]');
    if (activeReset) activeReset.hidden = count === 0 || !(this.material?.value || kind);
    this.querySelector('[data-empty]').hidden = count > 0;
    const url = new URL(location.href);
    [['am_material',this.material?.value],['am_kind',kind],['am_sort',sort === 'featured' ? '' : sort]].forEach(([k,v]) => v ? url.searchParams.set(k,v) : url.searchParams.delete(k));
    if (updateURL) history.pushState({},'',url);
    this.syncPagination(url.searchParams);
  }
  disconnectedCallback() {
    this.removeEventListener('change',this.onChange);
    window.removeEventListener('popstate',this.onPop);
    this.resetButtons?.forEach(button => button.removeEventListener('click', this.onReset));
    this.ready=false;
  }
}
if (!customElements.get('am-catalog')) customElements.define('am-catalog',AmCatalog);
